import { motion } from "framer-motion";
import { FaCheckCircle, FaChurch } from "react-icons/fa";
import { useLocation } from 'react-router-dom';
import PageHeader from '../common/PageHeader';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      when: "beforeChildren"
    }
  }
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 100,
      damping: 10
    }
  }
};

export default function GivingSuccess() {
    const location = useLocation();
      const queryParams = new URLSearchParams(location.search);
      const reference = queryParams.get('ref');
      const price = queryParams.get('price');
      const type = queryParams.get('type');
  return (
    <motion.main 
      className="w-full relative"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <PageHeader 
        title="Thank You For Your Offering" 
        subtitle="Your generosity makes a difference in God's kingdom"
        imageUrl="https://media.istockphoto.com/id/1080150772/photo/girl-in-a-light-sweater-gives-a-knitted-heart.jpg?s=170667a&w=0&k=20&c=CZ1l_QKyXrhsL-kzzswbvt_vmhsPbxkH3C6PJmqymyw="
        imageAlt="Giving"
      />

      <motion.section 
        className="relative z-20 bg-white -mt-8 pt-8 px-4 pb-8 shadow-lg"
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2 }}
      >
        <div className="max-w-4xl mx-auto">
          <motion.div 
            className="flex flex-col items-center text-center py-12 px-4"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            <motion.div 
              className="mb-8 text-green-500"
              variants={itemVariants}
            >
              <FaCheckCircle size={80} />
            </motion.div>
            
            <motion.h2 
              className="text-3xl font-bold text-gray-800 mb-4"
              variants={itemVariants}
            >
              Payment Successful!
            </motion.h2>
            
            <motion.p 
              className="text-xl text-gray-600 mb-8 max-w-2xl"
              variants={itemVariants}
            >
              Your offering has been received. We appreciate your generosity and faithfulness in supporting the ministry.
            </motion.p>
            {/*}
            <motion.div 
              className="w-full max-w-md bg-gray-50 rounded-xl p-6 mb-8 border-l-4 border-green-500"
              variants={itemVariants}
            >
              <h3 className="text-lg font-semibold mb-4 flex items-center">
                <FaHandHoldingHeart className="mr-2 text-green-500" />
                Your Receipt
              </h3>
              <div className="space-y-3 text-left">
                <p><span className="font-medium">Reference:</span> {reference}</p>
                <p><span className="font-medium">Amount:</span> R {price}</p>
                <p><span className="font-medium">Offering Type:</span> {type}</p>
                <p><span className="font-medium">Date:</span> {new Date().toLocaleDateString()}</p>
              </div>
            </motion.div>*/}
            
            <motion.div 
              className="flex flex-col sm:flex-row gap-4"
              variants={itemVariants}
            >
              <motion.a
                href="/giving"
                className="px-6 py-3 bg-primary hover:bg-primary-dark text-white font-medium rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition duration-200"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                Give Again
              </motion.a>
              <motion.a
                href="/"
                className="px-6 py-3 bg-white hover:bg-gray-50 text-gray-800 font-medium rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition duration-200"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                Return Home
              </motion.a>
            </motion.div>
            
            <motion.div 
              className="mt-12 pt-6 border-t border-gray-200 w-full max-w-md"
              variants={itemVariants}
            >
              <h3 className="text-lg font-semibold mb-4 flex items-center justify-center">
                <FaChurch className="mr-2 text-primary" />
                Need Assistance?
              </h3>
              <p className="text-gray-600 mb-4">
                If you have any questions about your offering, please contact our finance team.
              </p>
              <p className="text-primary font-medium">
                finance@yourchurch.org | (012) 345-6789
              </p>
            </motion.div>
          </motion.div>
        </div>
      </motion.section>
    </motion.main>
  );
}